import { Button, Card, Empty, Icon } from 'ui';
import { ChatPageLayout } from '../../chat-page-layout';

type P = {
  onCreateChatClicked: () => Promise<void>;
};

const EmptyMessages = ({ onCreateChatClicked }: P) => (
  <ChatPageLayout>
    <Card fullHeight>
      <Empty
        description={{ subtitle: 'Create a message to start a new conversation', title: 'No messages yet' }}
        fitCenter
        image={<Icon icon="inbox-line" />}
      >
        <Button onClick={onCreateChatClicked} type="link-primary">
          Create a message
        </Button>
      </Empty>
    </Card>
  </ChatPageLayout>
);

export default EmptyMessages;
